const headTag = "<head>";

export const getContentStyle = theme => {
  return `
    .mce-content-body {
      font-family: ${theme.typography.body1.fontFamily};
      margin: 8px;
    }
    .bg-primary {
      background-color: ${theme.palette.primary.main} !important;
    }
    .bg-light {
      background-color: ${theme.palette.primary.light} !important;
    }
    .bg-secondary {
      background-color: ${theme.palette.secondary[50]} !important;
    }
    .btn-primary {
      color: ${theme.palette.primary.main} !important;
    }
    .small {
      font-size: 14px;
    }
    .bold {
      font-weight: 600
    }
    .semi-bold {
      font-weight: 500
    }
    .text-primary {
      color: ${theme.palette.primary.main} !important;
    }
    a {
      color: ${theme.palette.primary.main} !important;
    }
    a.text-primary:focus,
    a.text-primary:hover {
      color: ${theme.palette.primary.dark} !important;
    }
  `;
};

export const insertCustomerStyles = (htmlContent, theme) => {
  const styles = getContentStyle(theme);
  if (htmlContent) {
    const positionToInsertStyles =
      htmlContent.indexOf(headTag) + headTag.length;
    return [
      htmlContent.slice(0, positionToInsertStyles),
      `<style>${styles}</style>`,
      htmlContent.slice(positionToInsertStyles)
    ].join("");
  } else {
    return htmlContent;
  }
};
